import { useEffect } from 'react'
import { NextRouter } from 'next/router'

import { EventDetectionMethod, EventType, TestPrepGrade } from '~/behavior-tracking/types'
import { logUserActivity } from '~/behavior-tracking/utility/view-event-logs.utility'

export default function usePageLeaveTracker(
  router: NextRouter,
  userId: number | null,
  testPrepGrade?: TestPrepGrade,
): void {
  useEffect(() => {
    const onRouteChangeStart = async (newPath: string) => {
      const currentPath = router.asPath

      if (userId != null && newPath !== currentPath) {
        const event = {
          eventName: EventType.LEAVE_PAGE,
          viewKey: router.asPath,
          extra: {
            detectBy: EventDetectionMethod.NEXT_ROUTE_CHANGE_START_EVENT,
            testPrepGrade,
          },
        }

        await logUserActivity(userId, event)
      }
    }

    router.events.on('routeChangeStart', onRouteChangeStart)

    return () => {
      router.events.off('routeChangeStart', onRouteChangeStart)
    }
  }, [router, testPrepGrade, userId])
}
